import { TranslationKey } from './TranslationKey'

export interface TranslationFile {
    modified: boolean
    id: number
    doneCount: number
    translationsKeys: Record<number, TranslationKey>
}

export function createTranslationFile(): TranslationFile {
    return {
        modified: false,
        id: 0,
        doneCount: 0,
        translationsKeys: {}
    }
}
